import { useMemo, useState } from "react";
import { featured } from "@/mocks/home";
import Reveal from "./Reveal";

export default function Featured() {
  const tags = useMemo(() => ["全部", ...Array.from(new Set(featured.map((f) => f.tag)))], []);
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? featured : featured.filter((f) => f.tag === active);

  return (
    <section id="featured" className="section-anchor bg-background-100/70 py-14 md:py-20">
      <div className="container-gua">
        <Reveal>
          <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
            <div className="max-w-xl">
              <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
                <i className="ri-award-line"></i>
                精华内容
              </span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
                口碑精选，编辑力荐的一篇搞定
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                不想刷遍全网？直接从这里开始——编辑部把最值得看的盘点按主题挑好放在这里。
              </p>
            </div>
            <div className="flex flex-wrap gap-2">
              {tags.map((t) => (
                <button
                  key={t}
                  type="button"
                  onClick={() => setActive(t)}
                  className={`whitespace-nowrap rounded-md px-3.5 py-1.5 text-sm font-medium transition ${
                    active === t
                      ? "bg-secondary-600 text-background-50"
                      : "bg-background-50 text-foreground-700 ring-1 ring-background-200 hover:text-secondary-700"
                  }`}
                >
                  {t}
                </button>
              ))}
            </div>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((item, idx) => (
            <Reveal key={item.id} delay={(idx % 3) * 60}>
              <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition hover:border-primary-300">
                <div className="relative h-44 w-full overflow-hidden sm:h-48">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={`${item.title} · 呱呱爆料精华内容`}
                    className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50">
                    {item.tag}
                  </span>
                  <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 rounded-md bg-black/45 px-2 py-1 text-xs text-background-50 backdrop-blur">
                    <i className="ri-time-line"></i>
                    约 {item.readTime} 分钟
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-heading text-base font-bold leading-snug text-foreground-900 transition group-hover:text-primary-700 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                    {item.excerpt}
                  </p>
                  <a
                    href="#download"
                    className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
                  >
                    阅读全文
                    <i className="ri-arrow-right-line transition group-hover:translate-x-0.5"></i>
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}